import { render, staticRenderFns } from "./MutiplayerTopBarIcon.vue?vue&type=template&id=3cc2e378&"
import script from "./MutiplayerTopBarIcon.vue?vue&type=script&lang=js&"
export * from "./MutiplayerTopBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports